import {createFileRoute} from '@tanstack/react-router';
import {HomeLayout} from '@features/flow/components/HomeLayout';
import {TutorialsView} from '@features/flow/components/TutorialsView';

export const Route = createFileRoute('/tutorials/')({component: TutorialsPage});

function TutorialsPage() {
  return (
    <HomeLayout currentView='tutorials'>
      <title>Banani | Tutorials</title>
      <TutorialsView />
    </HomeLayout>
  );
}
